import { render, staticRenderFns } from "./newsContent.vue?vue&type=template&id=7d614ebf&scoped=true&"
import script from "./newsContent.vue?vue&type=script&lang=js&"
export * from "./newsContent.vue?vue&type=script&lang=js&"
import style0 from "./newsContent.vue?vue&type=style&index=0&id=7d614ebf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d614ebf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d614ebf')) {
      api.createRecord('7d614ebf', component.options)
    } else {
      api.reload('7d614ebf', component.options)
    }
    module.hot.accept("./newsContent.vue?vue&type=template&id=7d614ebf&scoped=true&", function () {
      api.rerender('7d614ebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/components/newsContent.vue"
export default component.exports